


<div style="width: 100%; height: 100%; position: relative;" *ngIf="loading == true">
  <div style="display: flex; justify-content: center; align-items: center;">
    <img src="/Content/Images/spinner.gif" style="margin:auto;">
  </div>
</div>


<eve-container title='Call Recording Analysis' icon='fa fa-phone-square' *ngIf="loading == false">


  <mat-tab-group>
    <mat-tab label="Summary">

      {{ summary}}

    </mat-tab>
    <mat-tab label="Sentiment - {{sentiment.Sentiment | sentiment}}">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let sentence of sentiment?.Sentences" class="sentiment-{{ sentence.Sentiment | sentiment}}">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="fa-regular sentiment-icon sentiment-{{ sentence.Sentiment | sentiment}}-icon"></i>

              {{ sentence.Text}}

            </mat-panel-title>



          </mat-expansion-panel-header>
          <h3>Sentiment</h3>
          <p>
            {{ sentence.Sentiment  | sentiment}}
          </p>

          <h3>Confidence Scores</h3>
          <p>
            Positive: {{ sentence.ConfidenceScores.Positive * 100}}% <br />
            Neutral: {{ sentence.ConfidenceScores.Neutral * 100}}% <br />
            Negative: {{ sentence.ConfidenceScores.Negative * 100}}% <br />
          </p>
        </mat-expansion-panel>
      </mat-accordion>


    </mat-tab>

    <mat-tab label="Transcription">

      <button (click)="export()" mat-icon-button color="primary" aria-label="Example icon button with a home icon">
        <i class="fa-regular fa-download"></i>
        Export
      </button>

      <div style="white-space: pre-line;">{{ transcription}}</div>
    </mat-tab>
  </mat-tab-group>









</eve-container>
